import { api } from "@/client/api"

export default {

    getCurrentLocation() {
        return api.get("/locations/current")
    },

}
